export const changeLog = [
  {
    id: "log-1",
    date: "2026-10-10",
    version: "更新批次 #48",
    tag: "最新",
    items: [
      "主线路一、主线路二完成切换，均已核验可正常访问",
      "移动优化线路同步更新，弱网加载进一步优化",
      "新增一条备用线路，用于分散高峰时段的访问压力",
    ],
  },
  {
    id: "log-2",
    date: "2026-10-06",
    version: "更新批次 #47",
    tag: "常规",
    items: [
      "镜像入口完成例行维护，内容与主站完成同步",
      "补充了地址核验说明，方便用户自行判断可用性",
    ],
  },
  {
    id: "log-3",
    date: "2026-10-02",
    version: "更新批次 #46",
    tag: "常规",
    items: [
      "备用线路二更换服务节点，稳定性有所提升",
      "APP入口版本更新至 v3.2.1，修复若干闪退问题",
    ],
  },
  {
    id: "log-4",
    date: "2026-09-27",
    version: "更新批次 #45",
    tag: "常规",
    items: [
      "主线路二上线，与主线路一互为备份",
      "优化了手机端地址展示，复制操作更顺手",
    ],
  },
  {
    id: "log-5",
    date: "2026-09-21",
    version: "更新批次 #44",
    tag: "常规",
    items: [
      "完成一轮全线路可用性核验",
      "更新防走失指南，新增多设备备份建议",
    ],
  },
  {
    id: "log-6",
    date: "2026-09-15",
    version: "更新批次 #43",
    tag: "常规",
    items: [
      "移动优化线路首次上线",
      "整理访问方式对比，方便按需选择",
    ],
  },
];

export const faqItems = [
  {
    id: "faq-1",
    q: "为什么有时候打开地址却进不去？",
    a: "常见原因有三类：一是该地址本身已经调整或失效；二是你当前所在的网络环境暂时不通畅；三是访问高峰拥堵。建议先换用本页标注为「最近更新」的主线路，如果仍打不开再尝试备用线路或更换网络。",
  },
  {
    id: "faq-2",
    q: "最新网址多久更新一次？",
    a: "本页会在地址发生调整后尽快同步，通常按批次记录在「地址更新记录」中，并标注具体日期。建议把本页收藏起来，需要时回来查看即可，无需反复搜索。",
  },
  {
    id: "faq-3",
    q: "APP和网页版应该选哪一个？",
    a: "如果只是临时使用或设备空间紧张，直接用网页版最方便，无需安装；如果长期固定使用、希望启动更快，可以考虑安装APP。两者的核心内容是一致的，按自己的使用习惯选择即可。",
  },
  {
    id: "faq-4",
    q: "主线路打不开时该怎么办？",
    a: "不需要反复刷新同一条地址。直接在本页切换到备用线路，或者改用移动优化线路。多条线路分布在不同的节点上，互为备份就是为了应对这种情况。",
  },
  {
    id: "faq-5",
    q: "怎样才算真正做到「防走失」？",
    a: "核心是保留一个稳定的回访入口。把本页收藏并把地址备注到备忘录，再各存一条主线路和备用线路。这样即使某个地址失效，你仍然能通过本页取到新的可用入口。",
  },
  {
    id: "faq-6",
    q: "手机上如何快速保存这个页面？",
    a: "在手机浏览器中打开本页，点开浏览器菜单，选择「添加到主屏幕」。之后本页会以图标形式出现在桌面，点开即可查看最新地址，和打开APP的体验很接近。",
  },
  {
    id: "faq-7",
    q: "遇到要输入银行卡或验证码的页面怎么办？",
    a: "正规访问流程一般不会提出这类要求。遇到索要银行卡、验证码或其他敏感信息的页面，应立即关闭并停止操作，回到本页重新核对入口，避免进入仿冒页面。",
  },
  {
    id: "faq-8",
    q: "换一台设备后还能找到最新地址吗？",
    a: "可以。本页本身就是一个相对固定的信息页，在新设备上打开本页即可看到当前所有可用入口。建议平时就把本页地址用备忘录记录一份，跨设备也不受影响。",
  },
];